import { fetcher } from '@/services/api'
import useSWR from 'swr'
import { Account } from '@/types/models/Account'
import { accountRoutes } from './account.service'

interface Props {
  accountId?: number
}

export function useAccount(query: Props) {
  const { data, error, mutate, isLoading } = useSWR(
    () =>
      query.accountId ? [accountRoutes.get(query.accountId), {}] : undefined,
    fetcher<Account>,
    {
      revalidateIfStale: true,
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      suspense: false,
      shouldRetryOnError: false,
    }
  )

  return {
    data,
    refresh: mutate,
    isLoading,
    isError: error,
  }
}
